// Loader.jsx
import React from "react";
import { motion } from "framer-motion";
import "./styles/Loader.css"; // Make sure this is imported

const Loader = () => {
  return (
    <div className="loader-overlay">
      <motion.div
        className="loader-spinner"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, ease: "linear", duration: 1 }}
      />
    </div>
  );
};

export default Loader;
